// extracted by mini-css-extract-plugin
export default {"containerDefault":"Overlay_containerDefault__PVGRx","noScroll":"Overlay_noScroll__g5KxI"};